<span class="polaris-text" [ngClass]="['polaris-text--' + color, 'polaris-text--tone-' + tone]">
  <ng-content></ng-content>
</span>
